import Vue from "vue";
import request from "@/utils/request";
import App from "./App.vue";
import "./assets/css/style.css";
import filters from "@/filter";
Vue.use(filters);
Vue.config.productionTip = false;

const dev_id = "kcc_282634"; //测试id
// const dev_id = "kcc_13145"; //测试id



// const baseURL = "http://127.0.0.1:5000/";
// const baseURL = "http://im.video-force.cn:6002/";
// const baseURL = "http://im.jinlaijinwang.com:18799/";

const baseURL = "https://im.jinlaijinwang.com:19090/";
const accessLog = "https://im.jinlaijinwang.com:8443/api/IMAPI/";

// const baseURL = "http://im.jinlaijinwang.com:18899/";
// const accessLog = "http://im.jinlaijinwang.com:18811/api/IMAPI/";

request.defaults.baseURL = baseURL;
Vue.prototype.$baseURL = baseURL;
Vue.prototype.$accessLog = accessLog;
Vue.prototype.$dev_id = dev_id;

new Vue({
  render: h => h(App)
}).$mount("#jljw_IM_GdImBox");
